<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="39" height="33" viewBox="0 0 39 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_458_5641)">
                            <path
                                d="M32.8463 0H6.15368C4.97895 0 4 0.986779 4 2.17091V22.5315C4 23.7156 4.97895 24.7024 6.15368 24.7024H32.8463C34.0211 24.7024 35 23.7156 35 22.5315V2.17091C35 0.953886 34.0211 0 32.8463 0ZM13.2021 2.2367C13.7242 2.2367 14.1158 2.6643 14.1158 3.15769C14.1158 3.68397 13.6916 4.07869 13.2021 4.07869C12.68 4.07869 12.2884 3.65108 12.2884 3.15769C12.2558 2.63141 12.68 2.2367 13.2021 2.2367ZM10.3958 2.2367C10.9179 2.2367 11.3095 2.6643 11.3095 3.15769C11.3095 3.68397 10.8853 4.07869 10.3958 4.07869C9.87368 4.07869 9.48211 3.65108 9.48211 3.15769C9.44947 2.63141 9.87368 2.2367 10.3958 2.2367ZM7.55684 2.2367C8.07895 2.2367 8.47053 2.6643 8.47053 3.15769C8.47053 3.68397 8.04632 4.07869 7.55684 4.07869C7.06737 4.07869 6.64316 3.65108 6.64316 3.15769C6.64316 2.63141 7.06737 2.2367 7.55684 2.2367ZM32.2263 21.7091C32.2263 21.8078 32.1611 21.8736 32.0632 21.8736H6.93684C6.83895 21.8736 6.77368 21.8078 6.77368 21.7091V6.34828H32.2263V21.7091Z"
                                fill="#265D91" />
                            <path
                                d="M11.5045 15.4267H14.8329C15.2897 15.4267 15.714 15.1964 15.9424 14.7688L17.1497 12.6966L20.7066 18.7159C20.935 19.1107 21.3592 19.3738 21.8161 19.3738C22.2729 19.3738 22.6971 19.1435 22.9255 18.7159L24.8834 15.3938H27.4613C28.1792 15.3938 28.7666 14.8017 28.7666 14.0781C28.7666 13.3544 28.1792 12.7624 27.4613 12.7624H24.1655C23.7087 12.7624 23.2845 12.9926 23.0561 13.4202L21.8487 15.4925L18.2919 9.47311C17.835 8.68369 16.5297 8.68369 16.0403 9.47311L14.0824 12.7953H11.5045C10.7866 12.7953 10.1992 13.3873 10.1992 14.111C10.1992 14.8346 10.7866 15.4267 11.5045 15.4267Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_458_5641" x="0" y="0" width="39" height="32.7024"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_458_5641" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_458_5641"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>

                    Timesheet
                </h1>

                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted"> <a routerLink="/cra/liste-cra" class="text-muted">Liste des Timesheet</a></li>


                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

            <div class="card-body tools">
                <div class="title mb-15">
                    <h4>Liste des Timesheet</h4>
                </div>
                <div class="container">
                    <div class="row mb-3">
                        <div class="col-lg-3">
                            <div class=" mb-3">
                               <!-- <input  type="text" name="search" id="search" class="form-control mb-3 " placeholder="Rechercher"> -->
                               <input type="text" class="form-control form-control-lg px-15" name="search" (keyup)="searchListCraForMonth($event)"
                               placeholder="Rechercher ..." data-kt-customer-table-filter="search" />

                           
                            </div>
                        </div>
                        <div class="col-lg-4">


                        </div>

                    </div>

                    <div class="table-responsive mt-15">
                        <table class="table align-middle fs-6 gy-5 table-striped" id="list_cra">
                            <thead>
                                <th class="">
                                    Timesheet
                                </th>
                                <th class="">
                                    Candidat
                                </th>
                                <th class="">
                                    Validation
                                </th>
                                <th class="">
                                    Date
                                </th>
                                <th class="">
                                    Action
                                </th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let month of listtimesheetForMonths">
                                    <td class="cra">
                                        <a href="details-cra-candidat" class="cra-details">{{month.name}}</a>
                                    </td>
                                    <td class="text-center employe">
                                        {{month.project_candidate.consultant_client_final.candidate.first_name}}   {{month.project_candidate.consultant_client_final.candidate.last_name}}

                                 
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                            <rect *ngIf="month.state === 1" width="36" height="36" rx="9" fill="#B6ECC1" />
                                            <path *ngIf="month.state === 1"
                                              d="M14.9375 23.9919C15.1649 24.2181 15.4934 24.3688 15.8218 24.3688C16.1503 24.3688 16.4787 24.2181 16.7314 23.9919L27.621 13.1611C28.1263 12.6585 28.1263 11.8795 27.621 11.3769C27.1157 10.8744 26.3324 10.8744 25.8271 11.3769L15.8218 21.3282L11.1729 16.6792C10.6676 16.1767 9.88431 16.1767 9.37899 16.6792C8.87367 17.1818 8.87367 17.9608 9.37899 18.4634L14.9375 23.9919Z"
                                              fill="#265D91" />
                                            
                                            <rect *ngIf="month.state !== 1" x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke="#265D91"/>
                                            <path *ngIf="month.state !== 1"
                                              fill-rule="evenodd" clip-rule="evenodd" d="M15.7777 18.5013L11.3567 14.0804C10.8811 13.6047 10.8811 12.8324 11.3567 12.3567C11.8324 11.8811 12.6047 11.8811 13.0803 12.3567L17.4987 16.7751L21.9023 12.3581C22.3772 11.8817 23.1495 11.8805 23.6259 12.3554C24.1023 12.8303 24.1034 13.6027 23.6285 14.0791L19.2223 18.4987L23.6433 22.9197C24.1189 23.3953 24.1189 24.1676 23.6433 24.6433C23.1676 25.1189 22.3953 25.1189 21.9197 24.6433L17.5013 20.2249L13.0977 24.6419C12.6228 25.1183 11.8505 25.1195 11.3741 24.6446C10.8977 24.1697 10.8966 23.3973 11.3715 22.9209L15.7777 18.5013Z" 
                                              fill="#265D91"/>
                                          </svg>
                                    </td>
                                    <td class="text-center ">
                                       {{ formatDate(month.created_at) }}
                                    </td>
                                    <td>
                                        <a (click)="voirListDetailsTimeSheet(month?.id)" type="button" class="btn btn-details">
                                            Voir détail
                                        </a>
                                    </td>
                                </tr>
                        
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end::Content container-->
</div>